import { AutoBrightnessVariantProps } from 'common/Prose/nodeViews/Image/components/ImageVariant/Types'
import { ImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { Text } from 'blaze-ui/Text/Text'
import { Slider } from 'almanac-ui/Slider/Slider'
import { autoBrightness } from '@cloudinary/url-gen/actions/adjust'
import { useImageStore } from 'stores/ImageStore'
import { useId } from '@react-aria/utils'
import { useState } from 'react'

export const AutoBrightnessVariant = (props: AutoBrightnessVariantProps) => {
  const { variant } = props
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()
  const id = useId()
  const [localValue, setLocalValue] = useState(variant.qualifier ?? 100)

  if (!cloudinary) return null

  return (
    <ImageVariant {...props}>
      <Text variant="label" id={id}>
        Change blend
      </Text>
      <Slider
        aria-labelledby={id}
        minValue={0}
        maxValue={100}
        step={1}
        onChange={(value) => setLocalValue(value as number)}
        value={localValue}
        onChangeEnd={(value) => {
          const image = cloudinary.image(variant.sourceUrl.split('?')[0]).setDeliveryType('fetch')
          image.effect(autoBrightness(value as number))
          imageStore.clearVariants()
          imageStore.createVariant({ image, url: image.toURL(), action: 'auto_brightness', qualifier: value as number })
          setLocalValue(value as number)
        }}
      />
    </ImageVariant>
  )
}
